import { Button, Col, Form, notification, Popconfirm, Row } from 'antd';
import { commonApi } from 'api/commonApi';
import { useAppSelector } from 'app/hooks';
import InputField from 'components/Common/InputField/InputField';
import SelectField from 'components/Common/SelectField/SelectField';
import { selectInverterItemSidebar } from 'components/Common/Sidebar/sidebarSlice';
import { selectIsDisable } from 'features/Login/authSlice';
import * as React from 'react';
import style from './System.module.scss';
export interface SystemProps {
  inverterConfig: any;
}

export default function System(props: SystemProps) {
  const { inverterConfig } = props;
  const [form] = Form.useForm();
  const [isModalVisible, setIsModalVisible] = React.useState(false);
  const [inputList, setInputList] = React.useState([]);
  const inverterId = useAppSelector(selectInverterItemSidebar);
  const isDisable = useAppSelector(selectIsDisable);

  React.useEffect(() => {
    if (inverterConfig) {
      setInputList(inverterConfig.config.param_list);
    }
  }, [inverterConfig]);

  const openNotificationWithIcon = (type: string, message: string) => {
    if (type === 'success' || type === 'error') notification[type]({ message: message });
    return;
  };

  const handleOk = async (value: any) => {
    try {
      let newList: any = [];
      await Object.keys(value).forEach((x) => {
        let newObject = {
          key: x,
          value: parseFloat(value[x]),
        };
        newList = [...newList, newObject];
      });
      await commonApi.setValueOfProperties({
        id: inverterId,
        key: 'set-inverter-parameter',
        newList: newList,
      });
      openNotificationWithIcon('success', 'Successfully');
    } catch (error) {
      openNotificationWithIcon('error', 'Failed!');
    }
  };

  const getFields = (inputList: any) => {
    const children: any = [];
    inputList.map((item: any, index: number) => {
      if (item.input_type === 'NUMBER') {
        return children.push(<InputField key={item.key} item={item} />);
      } else {
        return children.push(<SelectField key={item.key} item={item} />);
      }
    });
    return children;
  };

  return (
    <Row align="top" className={style.root}>
      <Row className={style.header_info}>
        <Col span={19} className={style.header_label_info}>
          System Parameters
        </Col>
        <Col span={5} className={style.header_group_btn}>
          {isModalVisible && (
            <Button
              onClick={() => {
                form.resetFields();
                setIsModalVisible(false);
              }}
              className={style.btn_delete}
            >
              Reset
            </Button>
          )}
          <Popconfirm
            disabled={!isModalVisible ? true : false}
            placement="bottomLeft"
            title="Sure to save?"
            onConfirm={() => form.submit()}
          >
            <Button disabled={isDisable} className={style.btn_edit}>
              Save
              {/* <FiEdit style={{ marginLeft: '10px' }} /> */}
            </Button>
          </Popconfirm>
        </Col>
      </Row>
      <Row align="top" className={style.main_detail}>
        <Form
          layout="vertical"
          form={form}
          labelCol={{
            span: 8,
          }}
          wrapperCol={{
            span: 8,
          }}
          style={{ width: '100%' }}
          hideRequiredMark
          onFinish={(values) => handleOk(values)}
          onValuesChange={() => setIsModalVisible(true)}
        >
          {getFields(inputList)}
        </Form>
      </Row>
    </Row>
  );
}
